import React from 'react';

const HistoryIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1663 12.9711V14.2208V15.054H15.416"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9575 18.5197C16.1429 18.5197 17.915 16.7476 17.915 14.5622C17.915 12.3768 16.1429 10.6047 13.9575 10.6047C11.7712 10.6047 10 12.3768 10 14.5622C10 16.7476 11.7712 18.5197 13.9575 18.5197"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.015 16.2111H3.84483C2.87304 16.2111 2.08594 15.424 2.08594 14.4522V3.8989C2.08594 2.92712 2.87304 2.14001 3.84483 2.14001H12.6393C13.6111 2.14001 14.3982 2.92712 14.3982 3.8989V10.6284"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.33594 5.55597H10.8348" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5.33594 8.88861H10.0016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5.33594 12.2213H7.50215" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default HistoryIcon;
